import {Injectable} from '@angular/core';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';

@Injectable()
export class WebSocketService {

  private socket;
  private stompClient;
  private attempts = {};

  constructor() {
  }

  public connect() {
    const socket = new SockJS('api/socket');
    // const socket = new SockJS('api/jsa-stomp-endpoint');
    // this.stompClient = Stomp.over(socket);
    // const url = 'ws://localhost:4200api/socket';
    // this.stompClient = Stomp.client(url);
    // const socket = new SockJS(url);
    // const socket = new SockJS('http://localhost:4200api/jsa-stomp-endpoint');
    this.stompClient = Stomp.over(socket);
    // this.stompClient = Stomp.client(url);
    // this.stompClient.connect({ Authorization: 'Bearer ' + localStorage.getItem(SettingENUM.TOKEN_STR)});
    return this.stompClient;
  }


  subscribe(dest, fn) {
    // console.log('this.attempts[dest]', this.attempts[dest], dest);
    if (!this.attempts[dest]) {
      this.attempts[dest] = {count: 1};
    }
    if (this.stompClient && this.stompClient.connected) {
      this.attempts[dest].count = 0;
      this.attempts[dest].subscribe = this.stompClient.subscribe(dest, res => {
        const frame = JSON.parse(res.body);
        if (frame) {
          fn(frame);
        }
      });
      return this.attempts[dest].subscribe;
    } else {
      if (this.stompClient == null) {
        this.connect();
        this.stompClient.connect({}, frame => {
          // console.log('frame', frame);
          this.attempts[dest].count = this.attempts[dest].count + 1;
          this.subscribe(dest, fn);
        });
      } else {
        if (this.attempts[dest].count < 10) {
          setTimeout(() => {
            this.attempts[dest].count = this.attempts[dest].count + 1;
            this.subscribe(dest, fn);
          }, 1000);
        }
      }
    }
  }

  unsubscribe(dest) {
    if (this.attempts[dest] && this.attempts[dest].subscribe) {
      this.attempts[dest].subscribe.unsubscribe();
      delete this.attempts[dest];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/web-socket.service.ts